export enum ImportStep {
	CREDENTIALS = 'credentials',
	MONITOR_SELECTION = 'monitor_selection',
}
